// extracted by mini-css-extract-plugin
export default {"menuPanel":"Menu_menuPanel__j6BuO"};